import axios from "axios";

const BACKEND_URL = "https://crm-backend-test-845189393450.asia-east1.run.app";
//const BACKEND_URL = "http://localhost:8080";
export const API_BASE = `${BACKEND_URL}/api/auth`;

export const api = axios.create({
    baseURL: API_BASE,
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// RESPONSE INTERCEPTOR: Handles expired tokens / 401 Unauthorized errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Clear session & redirect to login if JWT is invalid or expired
      localStorage.removeItem('auth_token');
      localStorage.removeItem('auth_user');
      window.location.href = '/login';
    }
    else if(error.response && error.response.status === 400) {
      // Clear session & redirect to login if JWT is invalid or expired
      localStorage.removeItem('auth_token');
      localStorage.removeItem('auth_user');
      window.location.href = '/login';
    } 
    return Promise.reject(error);
  }
);

export function formatApiError(detail) {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}
